import React, { useMemo } from 'react';

import { useRouteToMyTeamLevels } from 'Deer/hooks/useRouteToL3';
import { PageNotFound404 } from 'Deer/pages/PageNotFound404';
import PrivateRoute from 'components/PrivateRoute';
import { Route, Switch } from 'react-router-dom';

const MemoizedL3PrivateRoutes = () => {
  const { l3Options: tabs } = useRouteToMyTeamLevels();

  const memoizedPrivateRoutes = useMemo(
    () =>
      tabs.map((tab) => {
        const Component = tab.content;
        return tab.hide === undefined || tab.hide() === false ? (
          <PrivateRoute
            key={tab?.value}
            exact
            path={tab?.value}
            // eslint-disable-next-line react/no-unstable-nested-components
            component={() => (
              <Component
                cohort={{
                  id: tab.cohortId,
                  name: tab.label,
                  type: tab?.type,
                }}
                headerLabel={tab.headerLabel}
              />
            )}
          />
        ) : null;
      }),
    [tabs]
  );

  return (
    <Switch>
      {memoizedPrivateRoutes}
      <Route path="*" component={PageNotFound404} />
    </Switch>
  );
};

export { MemoizedL3PrivateRoutes };
